import Highcharts from "highcharts/esm/highcharts.src"

import "highcharts/esm/modules/drilldown.src"

import { useEffect, useState } from "react"
import ReactDOM from "react-dom"
import ReactServer from "react-dom/server"

const generateTooltipId = (chartId: number) =>
  `highcharts-custom-tooltip-${chartId}`

interface Props {
  chart: Highcharts.Chart | null
  children(formatterContext: Highcharts.Point[]): JSX.Element
  series?: Highcharts.SeriesOptionsType[]
}

export const PortfolioAnalyticsTooltip = ({
  chart,
  children,
  series,
}: Props) => {
  const [context, setContext] = useState<Highcharts.Point[]>([])

  useEffect(() => {
    if (chart?.options) {
      const formatter: Highcharts.TooltipFormatterCallbackFunction =
        function () {
          setContext(this.points ?? [])
          return ReactServer.renderToString(
            <div id={generateTooltipId(chart.index)}></div>
          )
        }

      chart.update({
        tooltip: {
          formatter,
        },
      })
    }
  }, [chart, chart?.options, chart?.series, series])

  const node = chart && document.getElementById(generateTooltipId(chart.index))

  return node && context ? ReactDOM.createPortal(children(context), node) : null
}
